import {FC} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Modal, Typography} from '@mui/material';

import {EmpionButton} from '../../../../../components/EmpionButton/EmpionButton';
import {empionGreen} from '../../../../../layouts/theme/EmpionColors';

export interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ProfilePhotoDeleteModal: FC<Props> = ({open, onClose, onConfirm}) => {
  const {t} = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          backgroundImage: 'none',
          borderRadius: '16px',
          padding: '32px',
          outline: 'none',
          width: '400px',
          height: '250px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Typography variant='h3' sx={{color: empionGreen[700]}}>
          {t('applicantProfile.profilePicture.deleteTitle')}
        </Typography>
        <Typography variant='body1'>{t('applicantProfile.profilePicture.removeConfirmation')}</Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 4,
          }}
        >
          <EmpionButton
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            color='primary'
            sx={{
              marginRight: '16px',
              flex: 1,
            }}
          >
            {t('shared.formButtons.cancel')}
          </EmpionButton>
          <EmpionButton
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();
            }}
            color='secondary'
            sx={{
              flex: 1,
            }}
          >
            {t('shared.formButtons.delete')}
          </EmpionButton>
        </Box>
      </Box>
    </Modal>
  );
};
